import { useEffect, useRef, useState } from 'react';
export function useRequest({ deps, initial, request }) {
    const [status, setStatus] = useState('idle');
    const [response, setResponse] = useState(initial);
    const requestCount = useRef(0);
    useEffect(() => {
        if ('isEnabled' in deps && !deps.isEnabled) {
            return;
        }
        const currentRequest = ++requestCount.current;
        if (requestCount.current === 1 && initial) {
            // No need to do an initial fetch as initial data is provided
            return;
        }
        setStatus('loading');
        request()
            .then((result) => {
            if (currentRequest === requestCount.current) {
                setResponse(result);
                setStatus('idle');
            }
        })
            .catch((error) => {
            if (currentRequest === requestCount.current) {
                setStatus('error');
            }
            throw error;
        });
    }, deps);
    return {
        response,
        status,
    };
}
